/* eslint-disable */
import * as signalR from '@microsoft/signalr'
import settings from './components/settings'

const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms))

class Connector {
  #connection

  #listeners = new Map()

  constructor() {
    console.log('SignalR: create connector')
    this.#connection = new signalR.HubConnectionBuilder()
      .withUrl(`${settings.badaAppointmentApiUrl.slice(0, -4)}/notification/`)
      .configureLogging(signalR.LogLevel.Debug)
      .withAutomaticReconnect()
      .build()
  }

  async #start() {
    console.log('SignalR: starting')
    if (this.#connection.state !== signalR.HubConnectionState.Disconnected) {
      return
    }
    try {
      await this.#connection.start()
      console.log('SignalR: started')
      this.#setupListeners()
    } catch (error) {
      console.error(error)
    }
  }

  async #stop() {
    console.log('SignalR: stopping')
    try {
      await this.#connection.stop()
      console.log('SignalR: stopped')
    } catch (error) {
      console.error(error)
    }
  }

  #setupListeners() {
    this.#connection.onreconnecting((error) => {
      console.log('SignalR: Connection lost. Reconnecting.', error)
    })

    this.#connection.onreconnected(async (connectionId) => {
      console.log('SignalR: Reconnected. Connection ID:', connectionId)
      for (const [key, cb] of this.#listeners.entries()) {
        if (key === 'Reconnect') {
          cb()
        } else {
          await this.#subscribe(key)
        }
      }
    })

    this.#connection.onclose((error) => {
      console.log('SignalR: Connection closed.', error)
    })
  }

  async #subscribe(appointmentId) {
    if (this.#connection.state === signalR.HubConnectionState.Disconnected) {
      await this.start()
    }

    while (
      this.#connection.state === signalR.HubConnectionState.Connecting ||
      this.#connection.state === signalR.HubConnectionState.Reconnecting
    ) {
      console.log('SignalR: Connection is not ready ', appointmentId)
      await sleep(100)
    }

    if (this.#connection.state !== signalR.HubConnectionState.Connected) {
      console.log(
        'SignalR: Failed connection ' + this.#connection.state,
        appointmentId
      )
      return
    }

    console.log('SignalR: Subscribe to ', appointmentId)
    await this.#connection.send('Subscribe', appointmentId)
  }

  id() {
    return this.#connection.connectionId
  }

  state() {
    return this.#connection.state
  }

  async start() {
    console.log('SignalR: start listening')
    await this.#start()
    this.#connection.off('PrepformUpdated')
    this.#connection.on('PrepformUpdated', (data) => {
      console.log('SignalR: Received PrepformUpdated', data)
      for (const [k, cb] of this.#listeners.entries()) {
        if (k === 'Reconnect') {
          continue
        }
        if (typeof cb === 'function') {
          cb(data)
        }
      }
    })
  }

  async close() {
    this.#connection.off('PrepformUpdated')
    await this.#stop()
  }

  async onReconnect(callback) {
    this.#listeners.set('Reconnect', callback)
  }

  async offReconnect() {
    this.#listeners.delete('Reconnect')
  }

  async subscribe(appointmentId, callback) {
    await this.#subscribe(appointmentId)
    this.#listeners.set(appointmentId, callback)
  }

  async unsubscribe(appointmentId) {
    await this.#connection.send('Unsubscribe', appointmentId)
    this.#listeners.delete(appointmentId)

    if (!this.#listeners.size) {
      await this.close()
    }
  }
}

export const Connection = new Connector()
